import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldAlert } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Month = ({ m }) => (
  <div className="rounded-2xl border border-rose-100 bg-white p-3" data-testid={`pkv-month-${m.month}`}>
    <div className="mb-2 flex items-center justify-between">
      <p className="text-sm font-bold">{m.month}{m.grade ? ` · تقييمك ${m.grade}` : ""}{m.valid === false ? " · أداء غير صالح" : ""}</p>
      <span className="rounded-full bg-rose-50 px-2 py-0.5 text-xs font-bold text-rose-700" data-testid={`pkv-total-${m.month}`}>{m.total} ر.س</span>
    </div>
    <div className="space-y-1.5">
      {m.items.map((x) => (
        <div key={x.key} className={`flex items-start justify-between gap-2 rounded-lg p-2 text-xs ${x.amount ? "bg-rose-50/60" : "bg-slate-50 text-slate-400"}`} data-testid={`pkv-${m.month}-${x.key}`}>
          <div><p className="font-semibold">{x.title}</p>{x.reason && <p className="text-[11px] text-slate-500" dir="auto">{x.reason}</p>}</div>
          <b className={x.amount ? "text-rose-700" : ""}>{x.amount}</b>
        </div>
      ))}
    </div>
  </div>
);

export const PortalKeetaViolations = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/portal/keeta-violations`).then((r) => setD(r.data)).catch(() => setD({ months: [] })); }, []);
  if (!d?.months?.length) return null;
  return (
    <div className="space-y-2" data-testid="portal-keeta-violations">
      <p className="flex items-center gap-1.5 text-sm font-bold text-rose-700"><ShieldAlert className="h-4 w-4" /> خصومات وتقييم كيتا</p>
      {d.months.map((m) => <Month key={m.month} m={m} />)}
    </div>
  );
};
